export interface ChartData {
  value: number;
  label: string;
  data?: BarData;
}

export interface BarData {
  title: string;
  details: readonly BarDetail[];
}

export interface BarDetail {
  label: string;
  value: string | number;
}

export enum ChartType {
  BAR = 'bar',
}
